/* BlackBole Studio — header behaviour (drawer, search, cart count, scroll shadow). */
(function(){
  if(window.__bbsChrome)return;window.__bbsChrome=true;
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  var oldHdr=function(){return $('[id$="__header_section"]')};

  function boot(){
    var hdr=$('[data-bbs-hdr]'),drawer=$('[data-bbs-drawer]');
    if(!hdr)return;
    // drawer
    function setDrawer(open){if(!drawer)return;drawer.classList.toggle('open',open);drawer.setAttribute('aria-hidden',!open);document.documentElement.classList.toggle('bbs-lock',open);$$('[data-bbs-open]').forEach(function(b){b.setAttribute('aria-expanded',open)});if(open){var c=$('[data-bbs-close]',drawer.querySelector('.bbx-panel'));c&&c.focus()}}
    $$('[data-bbs-open]').forEach(function(b){b.addEventListener('click',function(){setDrawer(true)})});
    $$('[data-bbs-close]').forEach(function(b){b.addEventListener('click',function(){setDrawer(false)})});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')setDrawer(false)});
    // search: open the theme's predictive search modal, else go to /search
    $$('[data-bbs-search]').forEach(function(b){b.addEventListener('click',function(){
      var m=document.getElementById('search-modal');
      try{ if(m&&typeof m.showDialog==='function'){m.showDialog();return} var d=m&&m.querySelector('dialog'); if(d&&d.showModal){d.showModal();var i=d.querySelector('input');i&&i.focus();return} }catch(err){}
      location.href=(window.Theme&&Theme.routes&&Theme.routes.search_url)||'/search';
    })});
    // cart: open the theme's cart drawer when it exists, else go to /cart
    var cartLink=$('[data-bbs-cart]');
    if(cartLink)cartLink.addEventListener('click',function(e){
      var o=oldHdr(); if(!o)return;
      var drawerEl=o.querySelector('cart-drawer-component');
      var trigger=o.querySelector('[on\\:click*="cart-drawer"],.header-actions__cart-icon button,button.header-actions__action[aria-haspopup],cart-icon button,.cart-drawer__button,button[aria-controls*="cart"]');
      try{
        if(drawerEl&&typeof drawerEl.open==='function'){e.preventDefault();drawerEl.open();return}
        if(trigger){e.preventDefault();trigger.click();return}
      }catch(err){}
    });
    // cart count
    var countEl=$('[data-bbs-count]');
    function setCount(n){if(!countEl)return;countEl.textContent=n}
    function refresh(){fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){setCount(c.item_count)}).catch(function(){})}
    ['cart:update','cart:updated','cart:refresh','cart:add','theme:cart:update'].forEach(function(ev){document.addEventListener(ev,function(){setTimeout(refresh,250)})});
    document.addEventListener('submit',function(e){if(e.target&&e.target.action&&e.target.action.indexOf('/cart/add')>-1)setTimeout(refresh,1200)},true);
    window.addEventListener('pageshow',refresh);
    // scroll shadow
    function sc(){hdr.classList.toggle('is-scrolled',scrollY>8)}
    addEventListener('scroll',sc,{passive:true});sc();
    // close mega after click (touch devices)
    $$('.bbx-mega a',hdr).forEach(function(a){a.addEventListener('click',function(){document.activeElement&&document.activeElement.blur()})});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

/* Product page: description -> dropdowns (Key Features, Size Chart, Description) */
(function(){
  function build(root){
    if(root._bbs)return;root._bbs=1;
    var raw=root.querySelector('.bbs-acc__raw');if(!raw)return;
    var feats=[],desc=[],sizes=[],bucket='desc',sawList=false;
    raw.querySelectorAll('img').forEach(function(im){
      if(/size/i.test(im.getAttribute('src')||'')||/size/i.test(im.alt||'')){var p=im.closest('p')||im;sizes.push(im.cloneNode(true));p.parentNode&&p.parentNode.removeChild(p)}
    });
    function headText(el){
      var t=(el.textContent||'').replace(/\s+/g,' ').trim();
      if(/^H[1-6]$/.test(el.tagName))return t;
      if(el.tagName==='P'&&t&&t.length<60){var b=el.querySelector('strong,b');if(b&&b.textContent.replace(/\s+/g,' ').trim()===t)return t}
      return null;
    }
    Array.prototype.slice.call(raw.childNodes).forEach(function(n){
      if(n.nodeType===3){if(n.textContent.trim())(bucket==='feat'?feats:desc).push(n);return}
      if(n.nodeType!==1)return;
      var h=headText(n);
      if(h!==null){
        if(/feature/i.test(h)){bucket='feat';sawList=false;return}
        if(/^description:?$/i.test(h)){bucket='desc';return}
        if(/size\s*(chart|guide)/i.test(h)){bucket='desc';return}
        bucket='desc';desc.push(n);return;
      }
      if(bucket==='feat'){
        if(n.tagName==='UL'||n.tagName==='OL'){feats.push(n);sawList=true;return}
        if(sawList){bucket='desc';desc.push(n);return}
        feats.push(n);return;
      }
      desc.push(n);
    });
    function item(title,nodes,open,extra){
      var d=document.createElement('details');d.className='bbs-acc__item';if(open)d.open=true;
      var s=document.createElement('summary');s.innerHTML='<span></span><i aria-hidden="true"></i>';s.firstChild.textContent=title;d.appendChild(s);
      var b=document.createElement('div');b.className='bbs-acc__body rte';nodes.forEach(function(x){b.appendChild(x)});if(extra)b.appendChild(extra);d.appendChild(b);return d;
    }
    var out=document.createElement('div');out.className='bbs-acc__list';
    if(feats.length)out.appendChild(item('Key features',feats,true));
    var help=document.createElement('p');help.className='bbs-acc__help';help.innerHTML='Not sure about your size? <a target="_blank" rel="noopener">Ask us on WhatsApp →</a>';help.querySelector('a').href=root.getAttribute('data-wa')||'https://wa.me/8801805070650';
    var sz=sizes.map(function(im){im.loading='lazy';var w=document.createElement('div');w.className='bbs-acc__size';w.appendChild(im);return w});
    var szItem=item('Size chart',sz,false,help);szItem.id='bbx-size';out.appendChild(szItem);
    var hasDesc=desc.some(function(n){return (n.textContent||'').trim()||n.querySelector&&n.querySelector('img,iframe,video')});
    if(hasDesc)out.appendChild(item('Description',desc,!feats.length));
    else desc.forEach(function(n){out.appendChild(n)});
    var dl=document.createElement('div');dl.innerHTML='<p>Cash on delivery across Bangladesh. Check your pair while the delivery person is with you.</p><p>Free size exchange — totally free, no extra charge. Request it within 1–3 days of delivery, subject to stock.</p>'+(root.getAttribute('data-leather')==='1'?'<p>4-month leather warranty on this genuine leather pair.</p>':'')+'<p><a href="/pages/return-refund-exchange-policy" style="text-decoration:underline">Return, refund &amp; exchange policy</a></p>';
    out.appendChild(item('Delivery & exchange',Array.prototype.slice.call(dl.childNodes),false));
    raw.replaceWith(out);
    // smooth open/close
    out.querySelectorAll('details').forEach(function(d){
      var s=d.querySelector('summary'),b=d.querySelector('.bbs-acc__body');
      s.addEventListener('click',function(e){
        if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
        e.preventDefault();
        if(d.open){b.style.height=b.scrollHeight+'px';requestAnimationFrame(function(){b.style.height='0px'});d.classList.add('closing');setTimeout(function(){d.open=false;d.classList.remove('closing');b.style.height=''},280)}
        else{d.open=true;var h=b.scrollHeight;b.style.height='0px';requestAnimationFrame(function(){b.style.height=h+'px'});setTimeout(function(){b.style.height=''},300)}
      });
    });
  }
  function boot(){document.querySelectorAll('[data-bbs-acc]').forEach(build)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

/* Product page: mockup details (size help link, COD button look, buy bar) */
(function(){
  function onReady(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn()}
  onReady(function(){
    var main=document.querySelector('main[data-template^="product"]');if(!main)return;
    // size head: "Select size (EU)" + "Size help"
    function sizeHead(){
      var lg=main.querySelector('fieldset.variant-option legend');
      if(!lg||lg.querySelector('.bbx-size-help'))return;
      var chk=main.querySelector('fieldset.variant-option input:checked');
      var lab=document.createElement('span');lab.setAttribute('data-size-out','');lab.textContent=chk&&main.dataset.bbxPicked?('Size '+chk.value+' selected'):'Select size (EU)';
      var btn=document.createElement('button');btn.type='button';btn.className='bbx-size-help';btn.textContent='Size help';
      btn.addEventListener('click',function(e){e.preventDefault();var d=document.getElementById('bbx-size');if(d){if(!d.open)d.querySelector('summary').click();d.scrollIntoView({behavior:'smooth',block:'center'})}});
      lg.textContent='';lg.appendChild(lab);lg.appendChild(btn);
    }
    sizeHead();
    main.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('fieldset.variant-option')){main.dataset.bbxPicked='1';var o=main.querySelector('[data-size-out]');if(o)o.textContent='Size '+(e.target.value||'')+' selected'}});
    new MutationObserver(function(){sizeHead()}).observe(main,{childList:true,subtree:true});
    // EasySell button: black, like the mockup "Order with cash on delivery"
    function styleCod(){
      var b=document.getElementById('es-popup-button');if(!b)return false;
      var st={'background':'#111111','color':'#ffffff','border-color':'#111111','border-radius':'4px','box-shadow':'none','font-size':'13.5px','letter-spacing':'.06em','text-transform':'uppercase','min-height':'48px','font-family':'inherit'};
      for(var k in st)b.style.setProperty(k,st[k],'important');
      b.classList.remove('es-animation-active','cart-shaker');
      b.querySelectorAll('svg,img').forEach(function(x){x.style.setProperty('filter','invert(1)')});
      return true;
    }
    if(!styleCod()){var tries=0,iv=setInterval(function(){if(styleCod()||++tries>40)clearInterval(iv)},250)}
    new MutationObserver(function(){var b=document.getElementById('es-popup-button');if(b&&b.style.getPropertyValue('background')!=='rgb(17, 17, 17)'&&b.style.getPropertyValue('background')!=='#111111')styleCod()}).observe(main,{childList:true,subtree:true});
    // buy bar: "Order · cash on delivery" opens the COD form
    var tries2=0,iv2=setInterval(function(){
      var bar=document.querySelector('.bbs-buybar');if(!bar){if(++tries2>40)clearInterval(iv2);return}
      clearInterval(iv2);
      var b=bar.querySelector('button');if(!b)return;b.textContent='Order · cash on delivery';
      var nb=b.cloneNode(true);b.replaceWith(nb);
      nb.addEventListener('click',function(){var es=document.getElementById('es-popup-button');if(es){es.click()}else{var f=main.querySelector('form[action*="/cart/add"]');f&&f.scrollIntoView({behavior:'smooth',block:'center'})}});
    },250);
  });
})();

/* Collection page: gender / category / sort (mockup filter bar) */
(function(){
  function onReady(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn()}
  onReady(function(){
    var grid=document.querySelector('[data-bbx-grid]');if(!grid)return;
    var cells=Array.prototype.slice.call(grid.querySelectorAll('.bbx-cell')),count=document.querySelector('[data-bbx-count]'),empty=document.querySelector('[data-bbx-empty]');
    var st={gender:'all',cat:'all',sort:'featured'};
    function apply(anim){
      var list=cells.filter(function(c){return (st.gender==='all'||c.dataset.gender===st.gender)&&(st.cat==='all'||c.dataset.cat===st.cat)});
      if(st.sort==='featured')list.sort(function(a,b){return (b.dataset.avail-a.dataset.avail)||(a.dataset.i-b.dataset.i)});
      else list.sort(function(a,b){return st.sort==='low'?a.dataset.price-b.dataset.price:b.dataset.price-a.dataset.price});
      cells.forEach(function(c){c.hidden=true});
      list.forEach(function(c,k){c.hidden=false;grid.appendChild(c);if(anim){c.style.animation='none';void c.offsetWidth;c.style.animation='bbxIn .45s '+Math.min(k,12)*30+'ms both'}});
      if(count)count.textContent=list.length+(list.length===1?' style':' styles');
      if(empty)empty.hidden=list.length>0;
    }
    document.querySelectorAll('[data-bbx-filter]').forEach(function(g){var key=g.dataset.bbxFilter;g.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){g.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed',x===b)});st[key]=b.dataset.v;apply(true);
      try{var u=new URL(location.href);if(st[key]==='all')u.searchParams.delete(key);else u.searchParams.set(key,st[key]);history.replaceState(null,'',u)}catch(e){}})})});
    var sel=document.querySelector('[data-bbx-sort]');if(sel)sel.addEventListener('change',function(){st.sort=sel.value;apply(true)});
    var qs=new URLSearchParams(location.search);
    ['gender','cat'].forEach(function(k){var v=qs.get(k);if(!v)return;var b=document.querySelector('[data-bbx-filter="'+k+'"] button[data-v="'+v+'"]');if(b){document.querySelectorAll('[data-bbx-filter="'+k+'"] button').forEach(function(x){x.setAttribute('aria-pressed',x===b)});st[k]=v}});
    apply(false);
  });
})();
